<app-header></app-header>
<ng-container *ngIf="!isLoading">
    <div class="main-container">
        <div class="row">
            <div class="col-md-6 p-1">
                <div class="main-frame">
                    <div>
                        <div class="classification-title text-center">
                            Start your Classification Journey
                            <i class="fa-solid fa-arrow-right"></i>
                        </div>
                        <form [formGroup]="form">
                            <div class="container">
                                <div class="row dash-flex">
                                    <div class="col-12 col-md-6 col-lg-4">
                                        <input type="radio" formControlName="type" id="snowflake" value="snowflake"
                                            (click)="openGenerateClassification(false)" />
                                        <label for="snowflake">
                                            <span class="snowflake dash-label">
                                                <img class="icon-img" src="snowflake.png"
                                                    alt="snowflake" /><br />Snowflake Metadata
                                            </span>
                                        </label>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-4">
                                        <input type="radio" formControlName="type" id="snlowflakeWithAtlan"
                                            value="atlan" (click)="openGenerateClassification(true)" />
                                        <label for="snlowflakeWithAtlan"><span class="atlan dash-label">
                                                <img class="icon-img" src="atlan.png" alt="atlan" /> +
                                                <img class="icon-img" src="snowflake.png" alt="snowflake" /><br />
                                                <div>Atlan + Snowflake Metadata</div>
                                            </span></label>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-4">
                                        <input type="radio" formControlName="type" id="upload" value="upload"
                                            (click)="openFileUploadDialog()" />
                                        <label for="upload"><span class="upload dash-label">
                                                  <i class="fa-solid fa-cloud-arrow-up fa-2x upload-main-icon"></i>
                                                <br />Upload Your
                                                Files</span></label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-md-6 p-1">
                <div class="main-frame-second">
                    <div class="container p-0">
                        <div class="row">
                            <div class="col-md-6 pt-0">
                                <div *ngIf="!snowflakeStatus" class="connection-status disconnected pt-1 height-65">
                                    <div>Snowflake</div>
                                    <div class="status-label-disconnected">
                                        <span class="text-secondary">Connection Status: </span>
                                        <i class="fa-solid fa-xmark status-icon disconnected-background-color"></i>
                                        Disconnected
                                    </div>
                                </div>

                                <div *ngIf="snowflakeStatus" class="connection-status connected pt-1 height-65">
                                    <div>Snowflake</div>
                                    <div class="status-label-connected">
                                        <span class="text-secondary">Connection Status: </span>
                                        <i class="fa-solid fa-check status-icon connected-background-color"></i>
                                        Connected
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 pt-0">
                                <div *ngIf="!atlanStatus" class="connection-status disconnected pt-1 height-65">
                                    <div>Atlan</div>
                                    <div class="status-label-disconnected">
                                        <span class="text-secondary">Connection Status: </span>
                                        <i class="fa-solid fa-xmark status-icon disconnected-background-color"></i>
                                        Disconnected
                                    </div>
                                </div>

                                <div *ngIf="atlanStatus" class="connection-status connected pt-1 height-65">
                                    <div>Atlan</div>
                                    <div class="status-label-connected">
                                        <span class="text-secondary">Connection Status: </span>
                                        <i class="fa-solid fa-check status-icon connected-background-color"></i>
                                        Connected
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="height-5"></div>
                    <div class="container p-0">
                        <div class="row">
                            <div class="col-md-6">
                                <mat-card appearance="outlined" class="help-card height-80">
                                    <div class="help-option pt-1">
                                        <a href="https://wiki.app.pconnect.biz/spaces/AUC/pages/1529875515/AutoClassifier+DACA+-+Help+Documentation+Guide"
                                            class="help-option-link" target="_blank">
                                            <div class="help-icon">
                                                <i class="fa-solid fa-file-lines"></i>
                                            </div>
                                            <div class="help-label">Help & Documentation</div>
                                        </a>
                                    </div>
                                </mat-card>
                            </div>
                            <div class="col-md-6">
                                <mat-card appearance="outlined" class="help-card height-80">

                                    <div class="stat-card p-2">
                                        <div class="stat-icon mt-0">
                                            <i class="fa-solid fa-table"></i>
                                        </div>
                                        <div class="stat-info mt-0">
                                            <div class="stat-value">{{ total_files }}</div>
                                            <div class="stat-label">Total Tables Classified</div>
                                        </div>
                                    </div>
                                </mat-card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="main-container pt-0">
        <div class="table-card">
            <div class="card-header">
                <div class="table-heading flex-parent">
                    <span class="flex-item theme-color">
                        <i class="fa-solid fa-list"></i> &nbsp;
                        Recent Classification
                    </span>
                    <a class="flex-item" routerLink="/view-classification">
                        <span class="float-end theme-color">View All &nbsp;<i
                                class="fa-solid fa-arrow-right"></i></span>
                    </a>
                </div>
            </div>

            <div class="table-responsive">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Database</th>
                            <th>Schema</th>
                            <th>Table</th>
                            <th>Created By</th>
                            <th>Created On</th>
                            <th class="actions-column text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="files.length ==0">
                            <td colspan="6" class="text-center text-muted">
                                <div class="d-flex flex-column align-items-center gap-2">
                                    <i class="bi bi-inbox fs-4"></i> 
                                    <div>No data found</div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngFor="let script of files; let i = index">
                            <td>{{ script.database_name }}</td>
                            <td>{{ script.schema_name }}</td>
                            <td>{{ script.table_name }}</td>
                            <td>{{ script.saved_by }}</td>
                            <td>{{ script.created_at | date : "MMMM dd yyyy, h:mm a" }}</td>
                            <td class="actions-column text-center">
                                <i class="fa-solid fa-eye" (click)="viewClassification(script.filename)"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #descriptionDialog>
    <div class="description-dialog">
        <div class="classification-title px-3 py-2">
            <span>
                <i class="fa-solid fa-sheet-plastic"></i>
            </span>&nbsp;
            <span>Classification</span>
            <span class="float-end">
                <i class="fa-solid fa-close" aria-label="close dialog" [mat-dialog-close]="false"></i>
            </span>
        </div>

        <mat-dialog-content class="dialog-content padding-10" *ngIf="!isClassificationLoading">
            <pre>{{ classificationDetail | json }}</pre>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="dialog-actions" *ngIf="!isClassificationLoading">
            <div class="button-container">
                <button class="btn generate-btn download-button" (click)="downloadClassification(selectedFileName)">
                    <i class="fa-solid fa-download"></i> Download as CSV
                </button>
                <button class="btn generate-btn save-button" (click)="copyJSON()">
                    <i class="fa-solid fa-copy"></i> Copy
                </button>
            </div>
        </mat-dialog-actions>
    </div>

    <div *ngIf="isClassificationLoading" class="loader">
        <div class="loader-circle-11">
            <div class="arc"></div>
            <div class="arc"></div>
            <div class="arc"></div>
        </div>
    </div>
</ng-template>

<div *ngIf="isLoading" class="loader">
    <div class="loader-circle-11">
        <div class="arc"></div>
        <div class="arc"></div>
        <div class="arc"></div>
    </div>
</div>